var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFish = function SvgIconFish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.254 6.643a1 1 0 1 0-1.988-.217 3 3 0 0 0-.016.335 5.5 5.5 0 0 0 4.578 5.402 5.5 5.5 0 0 0 5.422 4.578h.216a1 1 0 0 0 0-2h-.216a3.5 3.5 0 0 1-3.5-3.5 1 1 0 0 0-1-1 3.5 3.5 0 0 1-3.5-3.493v-.02q-.001-.042.004-.085m6.871.482a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconFish;